/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_OPP_LIST
 */
export const listOpportunitiesQueryPageDefault = 1;export const listOpportunitiesQueryPageSizeDefault = 25;

export const listOpportunitiesQueryParams = zod.object({
  "page": zod.number().default(listOpportunitiesQueryPageDefault),
  "pageSize": zod.number().default(listOpportunitiesQueryPageSizeDefault),
  "status": zod.string().optional(),
  "hasShares": zod.boolean().optional(),
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional(),
  "talentIds": zod.array(zod.string().uuid()).optional()
})




export const listOpportunitiesResponseItemsItemPayRateValueMin = 0;
export const listOpportunitiesResponseItemsItemPayRateValueMax = 10000;

export const listOpportunitiesResponseItemsItemAddressAddressLine1Max = 255;

export const listOpportunitiesResponseItemsItemAddressAddressLine2Max = 255;

export const listOpportunitiesResponseItemsItemAddressCityMax = 255;

export const listOpportunitiesResponseItemsItemAddressStateMax = 2;

export const listOpportunitiesResponseItemsItemAddressZipMax = 10;

export const listOpportunitiesResponseItemsItemAddressCountryMax = 100;



export const listOpportunitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(listOpportunitiesResponseItemsItemPayRateValueMin).max(listOpportunitiesResponseItemsItemPayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(listOpportunitiesResponseItemsItemAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listOpportunitiesResponseItemsItemAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listOpportunitiesResponseItemsItemAddressCityMax).nullish(),
  "state": zod.string().max(listOpportunitiesResponseItemsItemAddressStateMax).nullish(),
  "zip": zod.string().max(listOpportunitiesResponseItemsItemAddressZipMax).nullish(),
  "country": zod.string().max(listOpportunitiesResponseItemsItemAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_OPP_CREATE
 */
export const createOpportunityBodyTitleMax = 255;

export const createOpportunityBodyReferenceRequirementsItemLabelMax = 100;

export const createOpportunityBodyReferenceRequirementsItemHintMax = 255;

export const createOpportunityBodyReferenceRequirementsItemExampleMax = 100;

export const createOpportunityBodyPayRateValueMin = 0;
export const createOpportunityBodyPayRateValueMax = 10000;

export const createOpportunityBodyNumberOfUnitsMax = 2147483647;

export const createOpportunityBodyMaxUnitsPerParticipantMax = 2147483647;

export const createOpportunityBodyMaxClaimsPerParticipantMax = 2147483647;

export const createOpportunityBodyMaxClaimsPerRosterMax = 2147483647;

export const createOpportunityBodyAddressAddressLine1Max = 255;

export const createOpportunityBodyAddressAddressLine2Max = 255;

export const createOpportunityBodyAddressCityMax = 255;

export const createOpportunityBodyAddressStateMax = 2;

export const createOpportunityBodyAddressZipMax = 10;

export const createOpportunityBodyAddressCountryMax = 100;

export const createOpportunityBodyUrlMax = 2048;



export const createOpportunityBody = zod.object({
  "title": zod.string().min(1).max(createOpportunityBodyTitleMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "label": zod.string().min(1).max(createOpportunityBodyReferenceRequirementsItemLabelMax),
  "masks": zod.array(zod.string()).nullish(),
  "hint": zod.string().max(createOpportunityBodyReferenceRequirementsItemHintMax).nullish(),
  "example": zod.string().max(createOpportunityBodyReferenceRequirementsItemExampleMax).nullish()
})).nullish(),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(createOpportunityBodyPayRateValueMin).max(createOpportunityBodyPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().min(1).max(createOpportunityBodyNumberOfUnitsMax).nullish(),
  "maxUnitsPerParticipant": zod.number().min(1).max(createOpportunityBodyMaxUnitsPerParticipantMax).nullish(),
  "maxClaimsPerParticipant": zod.number().min(1).max(createOpportunityBodyMaxClaimsPerParticipantMax).nullish(),
  "maxClaimsPerRoster": zod.number().min(1).max(createOpportunityBodyMaxClaimsPerRosterMax).nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(createOpportunityBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(createOpportunityBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(createOpportunityBodyAddressCityMax).nullish(),
  "state": zod.string().max(createOpportunityBodyAddressStateMax).nullish(),
  "zip": zod.string().max(createOpportunityBodyAddressZipMax).nullish(),
  "country": zod.string().max(createOpportunityBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().max(createOpportunityBodyUrlMax).nullish(),
  "isActive": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_OPP_GET
 */
export const getOpportunityByIdParams = zod.object({
  "id": zod.string().uuid()
})




export const getOpportunityByIdResponsePayRateValueMin = 0;
export const getOpportunityByIdResponsePayRateValueMax = 10000;

export const getOpportunityByIdResponseAddressAddressLine1Max = 255;

export const getOpportunityByIdResponseAddressAddressLine2Max = 255;

export const getOpportunityByIdResponseAddressCityMax = 255;

export const getOpportunityByIdResponseAddressStateMax = 2;

export const getOpportunityByIdResponseAddressZipMax = 10;

export const getOpportunityByIdResponseAddressCountryMax = 100;



export const getOpportunityByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(getOpportunityByIdResponsePayRateValueMin).max(getOpportunityByIdResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(getOpportunityByIdResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getOpportunityByIdResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getOpportunityByIdResponseAddressCityMax).nullish(),
  "state": zod.string().max(getOpportunityByIdResponseAddressStateMax).nullish(),
  "zip": zod.string().max(getOpportunityByIdResponseAddressZipMax).nullish(),
  "country": zod.string().max(getOpportunityByIdResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_UPDATE
 */
export const updateOpportunityParams = zod.object({
  "id": zod.string().uuid()
})

export const updateOpportunityBodyTitleMax = 255;

export const updateOpportunityBodyReferenceRequirementsItemLabelMax = 100;

export const updateOpportunityBodyReferenceRequirementsItemHintMax = 255;

export const updateOpportunityBodyReferenceRequirementsItemExampleMax = 100;

export const updateOpportunityBodyPayRateValueMin = 0;
export const updateOpportunityBodyPayRateValueMax = 10000;

export const updateOpportunityBodyNumberOfUnitsMax = 2147483647;

export const updateOpportunityBodyMaxUnitsPerParticipantMax = 2147483647;

export const updateOpportunityBodyMaxClaimsPerParticipantMax = 2147483647;

export const updateOpportunityBodyMaxClaimsPerRosterMax = 2147483647;

export const updateOpportunityBodyAddressAddressLine1Max = 255;

export const updateOpportunityBodyAddressAddressLine2Max = 255;

export const updateOpportunityBodyAddressCityMax = 255;

export const updateOpportunityBodyAddressStateMax = 2;

export const updateOpportunityBodyAddressZipMax = 10;

export const updateOpportunityBodyAddressCountryMax = 100;

export const updateOpportunityBodyUrlMax = 2048;



export const updateOpportunityBody = zod.object({
  "title": zod.string().max(updateOpportunityBodyTitleMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "label": zod.string().min(1).max(updateOpportunityBodyReferenceRequirementsItemLabelMax),
  "masks": zod.array(zod.string()).nullish(),
  "hint": zod.string().max(updateOpportunityBodyReferenceRequirementsItemHintMax).nullish(),
  "example": zod.string().max(updateOpportunityBodyReferenceRequirementsItemExampleMax).nullish()
})).nullish(),
  "requireImage": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(updateOpportunityBodyPayRateValueMin).max(updateOpportunityBodyPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().min(1).max(updateOpportunityBodyNumberOfUnitsMax).nullish(),
  "maxUnitsPerParticipant": zod.number().min(1).max(updateOpportunityBodyMaxUnitsPerParticipantMax).nullish(),
  "maxClaimsPerParticipant": zod.number().min(1).max(updateOpportunityBodyMaxClaimsPerParticipantMax).nullish(),
  "maxClaimsPerRoster": zod.number().min(1).max(updateOpportunityBodyMaxClaimsPerRosterMax).nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateOpportunityBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateOpportunityBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateOpportunityBodyAddressCityMax).nullish(),
  "state": zod.string().max(updateOpportunityBodyAddressStateMax).nullish(),
  "zip": zod.string().max(updateOpportunityBodyAddressZipMax).nullish(),
  "country": zod.string().max(updateOpportunityBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().max(updateOpportunityBodyUrlMax).nullish(),
  "isActive": zod.boolean()
})




export const updateOpportunityResponsePayRateValueMin = 0;
export const updateOpportunityResponsePayRateValueMax = 10000;

export const updateOpportunityResponseAddressAddressLine1Max = 255;

export const updateOpportunityResponseAddressAddressLine2Max = 255;

export const updateOpportunityResponseAddressCityMax = 255;

export const updateOpportunityResponseAddressStateMax = 2;

export const updateOpportunityResponseAddressZipMax = 10;

export const updateOpportunityResponseAddressCountryMax = 100;



export const updateOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(updateOpportunityResponsePayRateValueMin).max(updateOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(updateOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(updateOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(updateOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(updateOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(updateOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(updateOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_UPDATE
 */
export const patchOpportunityParams = zod.object({
  "id": zod.string().uuid()
})

export const patchOpportunityBodyTitleMax = 255;

export const patchOpportunityBodyReferenceRequirementsItemLabelMax = 100;

export const patchOpportunityBodyReferenceRequirementsItemHintMax = 255;

export const patchOpportunityBodyReferenceRequirementsItemExampleMax = 100;

export const patchOpportunityBodyPayRateValueMin = 0;
export const patchOpportunityBodyPayRateValueMax = 10000;

export const patchOpportunityBodyAddressAddressLine1Max = 255;

export const patchOpportunityBodyAddressAddressLine2Max = 255;

export const patchOpportunityBodyAddressCityMax = 255;

export const patchOpportunityBodyAddressStateMax = 2;

export const patchOpportunityBodyAddressZipMax = 10;

export const patchOpportunityBodyAddressCountryMax = 100;

export const patchOpportunityBodyUrlMax = 2048;



export const patchOpportunityBody = zod.object({
  "title": zod.string().max(patchOpportunityBodyTitleMax).nullish(),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']).optional(),
  "type": zod.enum(['Incentive', 'Job']).optional(),
  "requireGpsCheckIn": zod.boolean().nullish(),
  "enableGpsCheckIn": zod.boolean().nullish(),
  "referenceRequirements": zod.array(zod.object({
  "label": zod.string().min(1).max(patchOpportunityBodyReferenceRequirementsItemLabelMax),
  "masks": zod.array(zod.string()).nullish(),
  "hint": zod.string().max(patchOpportunityBodyReferenceRequirementsItemHintMax).nullish(),
  "example": zod.string().max(patchOpportunityBodyReferenceRequirementsItemExampleMax).nullish()
})).nullish(),
  "requireImage": zod.boolean().nullish(),
  "requireDescription": zod.boolean().nullish(),
  "requireTimeSheet": zod.boolean().nullish(),
  "payoutInstructions": zod.string().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(patchOpportunityBodyPayRateValueMin).max(patchOpportunityBodyPayRateValueMax).nullish()
}).optional(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(patchOpportunityBodyAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(patchOpportunityBodyAddressAddressLine2Max).nullish(),
  "city": zod.string().max(patchOpportunityBodyAddressCityMax).nullish(),
  "state": zod.string().max(patchOpportunityBodyAddressStateMax).nullish(),
  "zip": zod.string().max(patchOpportunityBodyAddressZipMax).nullish(),
  "country": zod.string().max(patchOpportunityBodyAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean().nullish(),
  "url": zod.string().max(patchOpportunityBodyUrlMax).nullish(),
  "isActive": zod.boolean().nullish()
})




export const patchOpportunityResponsePayRateValueMin = 0;
export const patchOpportunityResponsePayRateValueMax = 10000;

export const patchOpportunityResponseAddressAddressLine1Max = 255;

export const patchOpportunityResponseAddressAddressLine2Max = 255;

export const patchOpportunityResponseAddressCityMax = 255;

export const patchOpportunityResponseAddressStateMax = 2;

export const patchOpportunityResponseAddressZipMax = 10;

export const patchOpportunityResponseAddressCountryMax = 100;



export const patchOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(patchOpportunityResponsePayRateValueMin).max(patchOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(patchOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(patchOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(patchOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(patchOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(patchOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(patchOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_DELETE
 */
export const deleteOpportunityParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_CREATE
 */
export const createOpportunityFromTemplateBody = zod.object({
  "templateId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_PUBLISH
 */
export const shareOpportunityParams = zod.object({
  "id": zod.string().uuid()
})




export const shareOpportunityResponsePayRateValueMin = 0;
export const shareOpportunityResponsePayRateValueMax = 10000;

export const shareOpportunityResponseAddressAddressLine1Max = 255;

export const shareOpportunityResponseAddressAddressLine2Max = 255;

export const shareOpportunityResponseAddressCityMax = 255;

export const shareOpportunityResponseAddressStateMax = 2;

export const shareOpportunityResponseAddressZipMax = 10;

export const shareOpportunityResponseAddressCountryMax = 100;



export const shareOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(shareOpportunityResponsePayRateValueMin).max(shareOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(shareOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(shareOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(shareOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(shareOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(shareOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(shareOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_CLOSE
 */
export const closeOpportunityParams = zod.object({
  "id": zod.string().uuid()
})




export const closeOpportunityResponsePayRateValueMin = 0;
export const closeOpportunityResponsePayRateValueMax = 10000;

export const closeOpportunityResponseAddressAddressLine1Max = 255;

export const closeOpportunityResponseAddressAddressLine2Max = 255;

export const closeOpportunityResponseAddressCityMax = 255;

export const closeOpportunityResponseAddressStateMax = 2;

export const closeOpportunityResponseAddressZipMax = 10;

export const closeOpportunityResponseAddressCountryMax = 100;



export const closeOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(closeOpportunityResponsePayRateValueMin).max(closeOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(closeOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(closeOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(closeOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(closeOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(closeOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(closeOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_SHARE
 */
export const inviteToOpportunityParams = zod.object({
  "id": zod.string().uuid()
})

export const inviteToOpportunityBody = zod.object({
  "talentMemberIds": zod.array(zod.string().uuid())
})




export const inviteToOpportunityResponsePayRateValueMin = 0;
export const inviteToOpportunityResponsePayRateValueMax = 10000;

export const inviteToOpportunityResponseAddressAddressLine1Max = 255;

export const inviteToOpportunityResponseAddressAddressLine2Max = 255;

export const inviteToOpportunityResponseAddressCityMax = 255;

export const inviteToOpportunityResponseAddressStateMax = 2;

export const inviteToOpportunityResponseAddressZipMax = 10;

export const inviteToOpportunityResponseAddressCountryMax = 100;



export const inviteToOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(inviteToOpportunityResponsePayRateValueMin).max(inviteToOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(inviteToOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(inviteToOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(inviteToOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(inviteToOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(inviteToOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(inviteToOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_SHARE
 */
export const removeFromOpportunityParams = zod.object({
  "id": zod.string().uuid()
})

export const removeFromOpportunityBody = zod.object({
  "shareIds": zod.array(zod.string().uuid())
})




export const removeFromOpportunityResponsePayRateValueMin = 0;
export const removeFromOpportunityResponsePayRateValueMax = 10000;

export const removeFromOpportunityResponseAddressAddressLine1Max = 255;

export const removeFromOpportunityResponseAddressAddressLine2Max = 255;

export const removeFromOpportunityResponseAddressCityMax = 255;

export const removeFromOpportunityResponseAddressStateMax = 2;

export const removeFromOpportunityResponseAddressZipMax = 10;

export const removeFromOpportunityResponseAddressCountryMax = 100;



export const removeFromOpportunityResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string().min(1),
  "organizationLogoUrl": zod.string().nullish(),
  "title": zod.string().min(1),
  "description": zod.string().nullish(),
  "status": zod.enum(['Draft', 'Shared', 'Closed']),
  "type": zod.enum(['Incentive', 'Job']),
  "requireGpsCheckIn": zod.boolean(),
  "enableGpsCheckIn": zod.boolean(),
  "referenceRequirements": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string().min(1),
  "masks": zod.array(zod.string()),
  "hint": zod.string().nullish(),
  "example": zod.string().nullish()
})),
  "requireImage": zod.boolean(),
  "requireDescription": zod.boolean(),
  "requireTimeSheet": zod.boolean(),
  "payoutInstructions": zod.string().nullish(),
  "numberOfUnits": zod.number().nullish(),
  "maxUnitsPerParticipant": zod.number().nullish(),
  "maxClaimsPerParticipant": zod.number().nullish(),
  "maxClaimsPerRoster": zod.number().nullish(),
  "payRate": zod.object({
  "type": zod.enum(['Hourly', 'FlatRate', 'PerUnit', 'Percentage']).optional(),
  "value": zod.number().min(removeFromOpportunityResponsePayRateValueMin).max(removeFromOpportunityResponsePayRateValueMax).nullish()
}).optional(),
  "address": zod.object({
  "addressLine1": zod.string().max(removeFromOpportunityResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(removeFromOpportunityResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(removeFromOpportunityResponseAddressCityMax).nullish(),
  "state": zod.string().max(removeFromOpportunityResponseAddressStateMax).nullish(),
  "zip": zod.string().max(removeFromOpportunityResponseAddressZipMax).nullish(),
  "country": zod.string().max(removeFromOpportunityResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "startDate": zod.string().datetime({}).nullish(),
  "endDate": zod.string().datetime({}).nullish(),
  "isShareable": zod.boolean(),
  "url": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid(),
  "modifiedByUserId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_OPP_GET
 */
export const getOpportunitySharesParams = zod.object({
  "id": zod.string().uuid()
})

export const getOpportunitySharesQueryPageDefault = 1;export const getOpportunitySharesQueryPageSizeDefault = 25;

export const getOpportunitySharesQueryParams = zod.object({
  "page": zod.number().default(getOpportunitySharesQueryPageDefault),
  "pageSize": zod.number().default(getOpportunitySharesQueryPageSizeDefault)
})

export const getOpportunitySharesResponseItemsItemTalentAddressAddressLine1Max = 255;

export const getOpportunitySharesResponseItemsItemTalentAddressAddressLine2Max = 255;

export const getOpportunitySharesResponseItemsItemTalentAddressCityMax = 255;

export const getOpportunitySharesResponseItemsItemTalentAddressStateMax = 2;

export const getOpportunitySharesResponseItemsItemTalentAddressZipMax = 10;

export const getOpportunitySharesResponseItemsItemTalentAddressCountryMax = 100;





export const getOpportunitySharesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "talentId": zod.string().uuid().nullish(),
  "shareType": zod.enum(['User', 'Roster', 'Email', 'Link']),
  "sharedByUserId": zod.string().uuid().nullish(),
  "status": zod.enum(['Created', 'Sent', 'Viewed', 'Accepted', 'Expired']),
  "expiryDate": zod.string().datetime({}).nullish(),
  "message": zod.string().nullish(),
  "userId": zod.string().uuid().nullish(),
  "rosterId": zod.string().uuid().nullish(),
  "email": zod.string().nullish(),
  "shareUrl": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "talent": zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "type": zod.string().nullish(),
  "skills": zod.string().nullish(),
  "experience": zod.string().nullish(),
  "bio": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressCityMax).nullish(),
  "state": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressStateMax).nullish(),
  "zip": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressZipMax).nullish(),
  "country": zod.string().max(getOpportunitySharesResponseItemsItemTalentAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "tags": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string().min(1),
  "description": zod.string().nullish(),
  "hexColor": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({})
})).nullish(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "hasCompletedIdentityVerification": zod.boolean(),
  "identityVerificationEntityType": zod.enum(['Individual', 'Business']).optional(),
  "identityVerificationBusinessName": zod.string().nullish(),
  "hasLinkedBankAccount": zod.boolean(),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "primaryDestinationType": zod.enum(['BankAccount', 'DebitCard']).optional(),
  "hasPayoutEligibleCard": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "verifiedEmails": zod.array(zod.object({
  "id": zod.string().uuid(),
  "email": zod.string().min(1),
  "isPrimary": zod.boolean(),
  "verifiedDate": zod.string().datetime({})
}))
}).optional()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_OPP_LIST
 */
export const getOpportunityStatsResponse = zod.object({
  "all": zod.number(),
  "drafts": zod.number(),
  "shared": zod.number(),
  "claimed": zod.number(),
  "closed": zod.number()
})

/**
 * **Required Permission(s):** ORG_CLAIM_LIST
 */
export const getOpportunityClaimsParams = zod.object({
  "id": zod.string().uuid()
})

export const getOpportunityClaimsQueryPageDefault = 1;export const getOpportunityClaimsQueryPageSizeDefault = 25;

export const getOpportunityClaimsQueryParams = zod.object({
  "page": zod.number().default(getOpportunityClaimsQueryPageDefault),
  "pageSize": zod.number().default(getOpportunityClaimsQueryPageSizeDefault)
})

export const getOpportunityClaimsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "opportunityId": zod.string().uuid(),
  "numberOfUnits": zod.number().nullish(),
  "claimedBy": zod.string().uuid(),
  "claimerName": zod.string(),
  "claimDate": zod.string().datetime({}),
  "approvedBy": zod.string().uuid().nullish(),
  "approvalDate": zod.string().datetime({}).nullish(),
  "rejectedBy": zod.string().uuid().nullish(),
  "rejectionReason": zod.string().nullish(),
  "rejectionDate": zod.string().datetime({}).nullish(),
  "claimExpiryDate": zod.string().datetime({}).nullish(),
  "status": zod.enum(['Claimed', 'Approved', 'Rejected', 'Expired', 'Withdrawn', 'PayoutRequested', 'Returned']),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().optional(),
  "modifiedByUserId": zod.string().uuid().optional()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

